export const paymentSettingsKeys = {
  all: ['payment-settings'] as const,
  detail: () => [...paymentSettingsKeys.all, 'detail'] as const,
  publicProvider: () => [...paymentSettingsKeys.all, 'public-provider'] as const,
}
